export default __webpack_public_path__ + "static/media/18_masked_singer.42c80973.png";